module.exports = __webpack_public_path__ + "caaefd7daec6cc702bbee4aa667f0b50.svg";